import "./stepper.css"

interface StepperProps {
  currentStep?: number
  isInHouse?: boolean
  serviceRequestStatus?: string
}

export default function Stepper({ 
  currentStep = 0, 
  isInHouse = true, 
  serviceRequestStatus 
}: StepperProps) {
  const baseSteps = [
    { label: "Estimate & Assign", icon: "check" },
    { label: "In Progress", icon: "check" },
    { label: "Verify", icon: "check" },
  ]

  const steps = !isInHouse && serviceRequestStatus === "Payment Pending"
    ? [...baseSteps, { label: "Pay", icon: "check" }]
    : baseSteps

  // The last step (e.g. "Pay") must not read as blue/"completed" just for being the
  // current step -- "Payment Pending" and "Completed" both reach currentStep ===
  // steps.length - 1, but only "Completed" means the last step actually finished.
  // Every earlier step stays "completed" once passed; the current step is "active"
  // (gray, still shows the check icon) unless it's also the last step AND the request
  // is truly Completed.
  const stepClass = (index: number) => {
    if (index < currentStep) return "completed";
    if (index === currentStep) {
      const isLastStep = index === steps.length - 1;
      return isLastStep && serviceRequestStatus === "Completed" ? "completed" : "active";
    }
    return "";
  };

  return (
    <div className="stepper-container">
      {steps.map((step, index) => (
        <div key={index} className="step-item">
          <div className="step-content">
            <div
              className={`step-circle ${stepClass(index)}`}
            >
              {index <= currentStep ? (
                <svg className="check-icon" width="12" height="12" viewBox="0 0 12 12" fill="none">
                  <path
                    d="M10 3L4.5 8.5L2 6"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              ) : (
                <svg className="check-icon check-icon-disabled" width="12" height="12" viewBox="0 0 12 12" fill="none">
                  <path
                    d="M10 3L4.5 8.5L2 6"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
                // <div className="step-dot"></div>
              )}
            </div>
            <span
              className={`step-text ${stepClass(index)}`}
            >
              {step.label}
            </span>
          </div>
          {index < steps.length - 1 && (
            <div className={`step-connector ${index < currentStep ? "completed" : ""}`}></div>
          )}
        </div>
      ))}
    </div>
  )
}